const BROADCAST_SELECTION_KEY = "agrogrid_admin_broadcast_selection";
const DIRECTORY_SELECTIONS_KEY = "agrogrid_admin_directory_selections";
const supportedAudiences = new Set(["registered_users", "guest_users", "farms"]);

const normalizeIds = (ids) => [...new Set((Array.isArray(ids) ? ids : []).map(String).filter(Boolean))];
const normalizeRecipients = (recipients, ids) => {
  const allowedIds = new Set(ids);
  const unique = new Map();
  (Array.isArray(recipients) ? recipients : []).forEach((recipient) => {
    const id = String(recipient?.id || "");
    if (id && allowedIds.has(id)) unique.set(id, { id, name: recipient.name || "Selected recipient", detail: recipient.detail || "" });
  });
  ids.forEach((id) => { if (!unique.has(id)) unique.set(id, { id, name: "Selected recipient", detail: id }); });
  return [...unique.values()];
};
const normalizedSelection = (audience, ids, recipients = []) => {
  const normalizedIds = normalizeIds(ids);
  return { audience, ids: normalizedIds, recipients: normalizeRecipients(recipients, normalizedIds) };
};

const readDirectorySelections = () => {
  if (typeof window === "undefined") return {};
  try {
    const value = JSON.parse(window.sessionStorage.getItem(DIRECTORY_SELECTIONS_KEY));
    return value && typeof value === "object" ? value : {};
  } catch {
    window.sessionStorage.removeItem(DIRECTORY_SELECTIONS_KEY);
    return {};
  }
};

export const getAdminBroadcastSelection = () => {
  if (typeof window === "undefined") return { audience: "", ids: [], recipients: [] };
  try {
    const value = JSON.parse(window.sessionStorage.getItem(BROADCAST_SELECTION_KEY));
    if (!supportedAudiences.has(value?.audience)) return { audience: "", ids: [], recipients: [] };
    const ids = normalizeIds(value.ids);
    return { audience: value.audience, ids, recipients: normalizeRecipients(value.recipients, ids) };
  } catch {
    window.sessionStorage.removeItem(BROADCAST_SELECTION_KEY);
    return { audience: "", ids: [], recipients: [] };
  }
};

export const saveAdminBroadcastSelection = (audience, ids, recipients = []) => {
  const selection = normalizedSelection(audience, ids, recipients);
  if (typeof window !== "undefined" && supportedAudiences.has(audience)) {
    try {
      window.sessionStorage.setItem(BROADCAST_SELECTION_KEY, JSON.stringify(selection));
      const directorySelections = readDirectorySelections();
      directorySelections[audience] = selection;
      window.sessionStorage.setItem(DIRECTORY_SELECTIONS_KEY, JSON.stringify(directorySelections));
    } catch {

    }
  }
  return selection;
};

export const getAdminDirectorySelection = (audience) => {
  if (!supportedAudiences.has(audience)) return { audience: "", ids: [], recipients: [] };
  const stored = readDirectorySelections()[audience];
  if (stored) return normalizedSelection(audience, stored.ids, stored.recipients);
  const broadcastSelection = getAdminBroadcastSelection();
  return broadcastSelection.audience === audience
    ? broadcastSelection
    : normalizedSelection(audience, [], []);
};

export const saveAdminDirectorySelection = (audience, ids, recipients = []) => {
  const selection = normalizedSelection(audience, ids, recipients);
  if (typeof window !== "undefined" && supportedAudiences.has(audience)) {
    try {
      const directorySelections = readDirectorySelections();
      directorySelections[audience] = selection;
      window.sessionStorage.setItem(DIRECTORY_SELECTIONS_KEY, JSON.stringify(directorySelections));
    } catch {
      // In-memory directory state remains available for the current page session.
    }
  }
  return selection;
};
